import React from "react";

const getSubjectResults = (studentResult) => [
  ...(studentResult?.student_result || []),
  ...(studentResult?.student_result_grade_wise || []),
  ...(studentResult?.student_result_hifz || []),
];

const getSubjects = (students) => {
  const subjects = new Map();

  students.forEach((studentResult) => {
    getSubjectResults(studentResult).forEach((result) => {
      const subject = result?.subject;
      const key = subject?.id ?? subject?.slug ?? subject?.name;

      if (key != null && !subjects.has(key)) {
        subjects.set(key, subject);
      }
    });
  });

  return Array.from(subjects.entries()).map(([key, subject]) => ({
    key,
    ...subject,
  }));
};

const isAbsent = (result) =>
  String(result?.status || "").toLowerCase() === "absent";

const isFailed = (result) => {
  const grade = String(result?.grade || "")
    .trim()
    .toUpperCase();
  return !isAbsent(result) && (grade === "F" || grade === "FAIL");
};

const getSubjectResult = (studentResult, subjectKey) =>
  getSubjectResults(studentResult).find(
    (result) =>
      (result?.subject?.id ??
        result?.subject?.slug ??
        result?.subject?.name) === subjectKey,
  );

const formatPercentage = (value) => {
  if (value == null || value === "") return "-";
  return String(value).includes("%") ? value : `${value}%`;
};

const DetailedResultTable = ({
  students = [],
  textColor = "#000",
  selectable = false,
  allChecked = false,
  checkboxValues = [],
  onToggleAll,
  onToggleStudent,
}) => {
  const subjects = getSubjects(students);

  return (
    <div className="detailed-result-sheet">
      <div className="table-responsive detailed-result-table-wrapper">
        <table className="detailed-result-table" style={{ color: textColor }}>
          <thead>
            <tr>
              {selectable && (
                <th className="result-selection-column">
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onClick={onToggleAll}
                      checked={allChecked}
                      readOnly
                    />
                    <span />
                  </label>
                </th>
              )}
              <th>Adm-ID</th>
              <th className="student-name-column">Student Name</th>
              {/* <th>Mobile No.</th> */}
              {subjects.map((subject) => (
                <th key={subject.key} title={subject?.name}>
                  {subject?.slug || subject?.name}
                </th>
              ))}
              <th>Marks</th>
              <th>Grade</th>
              <th>%age</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {selectable && <td>{"--"}</td>}
              <td>{"--"}</td>
              <td
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  paddingRight: "10px",
                }}
              >
                {"Total Marks"}
              </td>
              {/* <td>{studentResult?.student?.mobile_no || "-"}</td> */}
              {subjects.map((subject) => {
                const subjectResult = getSubjectResult(
                  students[0],
                  subject.key,
                );

                return (
                  <td key={subject.key}>
                    <b>
                      {subjectResult
                        ? isAbsent(subjectResult)
                          ? "A"
                          : Number(subjectResult?.full_marks || 0)
                        : "--"}
                    </b>
                  </td>
                );
              })}
              <td>
                <b>
                  {students[0]?.student_final_result
                    ? students[0]?.student_final_result?.full_marks
                    : students[0]?.student_result_overall?.full_marks ?? "-"}
                </b>
              </td>
              <td>{"--"}</td>
              <td>{"--"}</td>
              <td>{"--"}</td>
            </tr>
            {students.map((studentResult, index) => {
              const overall = Array.isArray(
                studentResult?.student_result_overall,
              )
                ? studentResult?.student_final_result || {}
                : studentResult?.student_result_overall || {};

              return (
                <tr key={studentResult?.student?.id}>
                  {selectable && (
                    <td className="result-selection-column">
                      <label className="checkbox checkbox-single">
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          onClick={(event) =>
                            onToggleStudent?.(event, studentResult?.student?.id)
                          }
                          checked={Boolean(studentResult?.student?.checked)}
                          value={checkboxValues[index]}
                          readOnly
                        />
                        <span />
                      </label>
                    </td>
                  )}
                  <td>{studentResult?.student?.admission_id || "-"}</td>
                  <td className="student-name-column">
                    {studentResult?.student?.name || "-"}
                  </td>
                  {/* <td>{studentResult?.student?.mobile_no || "-"}</td> */}
                  {subjects.map((subject) => {
                    const subjectResult = getSubjectResult(
                      studentResult,
                      subject.key,
                    );

                    return (
                      <td key={subject.key}>
                        {subjectResult
                          ? isAbsent(subjectResult)
                            ? "A"
                            : Number(subjectResult?.gain_marks || 0) +
                              Number(subjectResult?.practical_marks || 0)
                          : "-"}
                      </td>
                    );
                  })}
                  <td>{overall?.total_gain_marks ?? "-"}</td>
                  <td>{overall?.grade || "-"}</td>
                  <td>{formatPercentage(overall?.percentage)}</td>
                  <td>{overall?.position || "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {subjects.length > 0 && (
        <div className="detailed-result-summary-wrapper">
          <table
            className="detailed-result-summary"
            style={{ color: textColor }}
          >
            <thead>
              <tr>
                <th>Subject Name</th>
                <th>Total</th>
                <th>Pass</th>
                <th>Fail</th>
                <th>Absent</th>
                <th>%age</th>
              </tr>
            </thead>
            <tbody>
              {subjects.map((subject) => {
                const results = students
                  .map((student) => getSubjectResult(student, subject.key))
                  .filter(Boolean);
                const absent = results.filter(isAbsent).length;
                const failed = results.filter(isFailed).length;
                const passed = results.length - absent - failed;
                const percentage = results.length
                  ? ((passed / results.length) * 100).toFixed(2)
                  : 0;

                return (
                  <tr key={subject.key}>
                    <th>{subject?.name || subject?.slug}</th>
                    <td>{results.length}</td>
                    <td>{passed}</td>
                    <td>{failed}</td>
                    <td>{absent}</td>
                    <td>{percentage}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DetailedResultTable;
